import { chartSeriesColor } from 'Utils/styleTokens';

const transformCategoryData = (riskCategories = {}, medicalEntityCount = 0) => {
  try {
    let totalPercent = 0;
    console.log('transformCategoryData medicalEntityCount', medicalEntityCount);
    // Use PHI category if medical entities > 1000, otherwise use personal
    const shouldUsePHI = medicalEntityCount > 1000;
    
    // Filter categories based on medical entity count

    const filteredCategories = { ...riskCategories };
    console.log('transformCategoryData filteredCategories', filteredCategories);
    if (shouldUsePHI) {
      // Use PHI category and hide personal
      if (filteredCategories.personal) {
        delete filteredCategories.personal;
      }
    } else {
      // Use personal category and hide PHI
      if (filteredCategories.PHI) {
        delete filteredCategories.PHI;
      }
    }
    console.log('transformCategoryData filteredCategories', filteredCategories);
    const categoryCount = Object.keys(filteredCategories).length;
    const colorArrValue = Array.from({ length: categoryCount }, (_, i) => chartSeriesColor(i));

    const categoryDataValue = [];

    for (const prop in filteredCategories) {
      const categoryData = filteredCategories[prop] || {};
      if (categoryData.score) {
        const findingsData = categoryData.topFindings || [];
        const findings = findingsData.map((finding) => {
          return {
            entity: finding,
            color: ''
          }
        })

        const item = {
          category: prop,
          findings: findings,
          score: categoryData.score,
          chartData: [
            {
              x: 0,
              y: categoryData.score,
              category: prop
            }
          ]
        };
        totalPercent += categoryData.score;
        categoryDataValue.push(item);
      }
    }
    categoryDataValue.sort((a, b) => b.score - a.score);
    let prevY = 0;
    categoryDataValue.forEach((obj, i) => {
      const chartData = obj.chartData[0];
      chartData.color = colorArrValue[i];
      obj.color = colorArrValue[i];
      chartData.y += prevY;
      prevY = chartData.y;
    });

    const totalSensitiveDataValue = [{
      x: 0,
      y: totalPercent,
      color: '#315DFF'
    }];
    categoryDataValue.reverse();
    console.log('transformCategoryData categoryDataValue final', categoryDataValue);
    return { categoryDataValue, totalSensitiveDataValue };
  } catch(e) {
    console.log(e);
    throw e;
  }
}

export { transformCategoryData };